import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import ROUTES from 'src/constants/routes'
import { useStyles } from './styles'
import { useAuth } from 'src/contexts/auth'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import EmailIcon from '@material-ui/icons/Email'
import PhoneIcon from '@material-ui/icons/Phone'
import { STORAGE_KEYS } from 'src/contexts/auth/constants'
import { isConfirmed } from 'src/contexts/auth/utils/confirmation.utils'

export const Confirmations: React.FC = () => {
  const navigate = useNavigate()
  const style = useStyles()

  const [phoneValidated, setPhoneValidated] = useState(false)
  const [emailValidated, setEmailValidated] = useState(false)

  const { phoneConfimed, emailConfimed } = useAuth()

  useEffect(() => {
    const phoneConfirmedStorage = localStorage.getItem(STORAGE_KEYS.PHONE_IS_CONFIRMED)
    const emailConfirmedStorage = localStorage.getItem(STORAGE_KEYS.EMAIL_IS_CONFIRMED)

    const isPhoneConfirmed = isConfirmed(phoneConfimed) || isConfirmed(phoneConfirmedStorage)
    const isEmailConfirmed = isConfirmed(emailConfimed) || isConfirmed(emailConfirmedStorage)

    setPhoneValidated(isPhoneConfirmed)
    setEmailValidated(isEmailConfirmed)

    if (isPhoneConfirmed && isEmailConfirmed) {
      navigate(ROUTES.DASHBOARD, { replace: true })
    }
  }, [phoneConfimed, emailConfimed])

  return (
    <div className={style.confirmationsWrapper}>
      <div className={style.confirmationsForm}>
        <div className={style.confirmationsTitleWrapper}>
          <h1>CONGADO</h1>
        </div>

        <div className={style.confirmationsInfoWrapper}>
          <h2>Confirmação da Conta</h2>
          <p className={style.confirmationsDescription}>
            Confirme seu telefone para acessar o sistema. A confirmação do e-mail é opcional, mas recomendada para maior
            segurança.
          </p>
        </div>

        <div className={style.confirmationsSelection}>
          <button
            className={`${style.confirmationsVerificationCard} ${
              phoneValidated ? style.confirmationsVerificationCardValidated : ''
            }`}
            onClick={() => !phoneValidated && navigate(ROUTES.AUTH.CONFIRM_PHONE)}
            disabled={phoneValidated}
          >
            <div className={style.confirmationsCardIcon}>
              {phoneValidated ? <CheckCircleOutlineIcon /> : <PhoneIcon />}
            </div>
            <div className={style.confirmationsCardContent}>
              <h3>{phoneValidated ? '✓ Telefone Confirmado' : 'Confirmar Telefone'}</h3>
              <p>{phoneValidated ? 'Seu telefone foi verificado com sucesso' : 'Enviaremos um código via WhatsApp'}</p>
            </div>
          </button>

          <button
            className={`${style.confirmationsVerificationCard} ${
              emailValidated ? style.confirmationsVerificationCardValidated : ''
            }`}
            onClick={() => !emailValidated && navigate(ROUTES.AUTH.CONFIRM_EMAIL)}
            disabled={emailValidated}
          >
            <div className={style.confirmationsCardIcon}>
              {emailValidated ? <CheckCircleOutlineIcon /> : <EmailIcon />}
            </div>
            <div className={style.confirmationsCardContent}>
              <h3>{emailValidated ? '✓ E-mail Confirmado' : 'Confirmar E-mail (opcional)'}</h3>
              <p>{emailValidated ? 'Seu e-mail foi verificado com sucesso' : 'Enviaremos um código para seu e-mail'}</p>
            </div>
          </button>

          {phoneValidated && (
            <button onClick={() => navigate(ROUTES.DASHBOARD)} className={style.confirmationsSkipButton}>
              Ir para o Dashboard
            </button>
          )}
        </div>
      </div>
      <div className={style.confirmationsImageSide}></div>
    </div>
  )
}
